// extracted by mini-css-extract-plugin
export default {"form":"JNx7sYnAb_mzqiklDUXv","space":"D8BMaG0UvF3Jylnv3WiA","placeHolderShimmer":"LiP7HY8zDf679AMEyfYu"};